jQuery.fn.imageCaptions = function() {
    this.each(function() {
    	var that = jQuery(this)
        if (that.parents().is(".captchaComponent")) {
            return;
        }
        var text = that.attr('alt');
        if (!text) { return };

        var wrapper = jQuery('<span></span>');
        wrapper.css({ width: that.width() });
        if (that.attr('align')){
        	wrapper.attr('align', that.attr('align'));
        }
        wrapper.attr('class', 'imageCaption ' + (that.attr('class') || ''));

        that.attr({align: ""});

        var parent = that.parents('a')[0];
        var stuffToWrap = (parent) ? that.parent() : that;
        stuffToWrap.wrap( wrapper )
            .parent()
            .append('<span>' + text + '</span>');
    });
}
jQuery.fn.bigClick = function(options) {
    var settings = {
        cssClass: 'clickable'
    }
    if (options) {
        jQuery.extend(settings, options);
    };

    this.each(function() {
        var anchor = jQuery(this).find('a')[0];

        if (!anchor)
            return;

        var href = jQuery(anchor).attr('href');
        var title = jQuery(anchor).attr('title');

        jQuery(this).attr('title', title);

        jQuery(this).mouseover(function() {
            jQuery(this).css('cursor', 'pointer');
        });

        jQuery(this).addClass(settings.cssClass).click(function() {
            window.location = href;
        });
    });
}


function common() {
    jQuery('.btn.books').append('<span class="arrow"></span>').bigClick();

    //Jquery Slider
    var currentValue = function(ui, maxval, minval, currentImg, dollarValue) {
        if (ui.value < maxval && ui.value > minval) {
            currentImg.fadeIn('fast').css({display: 'block'});
            var altText = currentImg.attr('title');
            jQuery('form#donateAmountDescription p').empty().append('= ' + altText);
            jQuery('form#donateAmount .inputText').val(dollarValue);
        } else {
            currentImg.fadeOut('fast');
        }
    }

    jQuery("ul.honorAFriendGifts li:odd").addClass("odd");

    jQuery('article img').imageCaptions();
}

jQuery(window).load(function() {
    common();
});
